interface IVideoIconProps {
  style?: React.CSSProperties;
  color?: string;
}

export const VideoIcon = ({ style, color = '#0F0F0F' }: IVideoIconProps): JSX.Element => {
  return (
    <div style={{ display: 'flex', ...style }}>
      <svg width="15" height="15" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.3024 1.73531C12.0424 1.60457 11.4971 1.46789 10.7551 1.9552L9.82293 2.57326C9.75317 0.725029 8.89707 0 6.81707 0H3.0122C0.843415 0 0 0.7904 0 2.82286V7.57714C0 8.944 0.792683 10.4 3.0122 10.4H6.81707C8.89707 10.4 9.75317 9.67497 9.82293 7.82674L10.7551 8.4448C11.1483 8.70629 11.4907 8.78949 11.7634 8.78949C11.998 8.78949 12.182 8.72411 12.3024 8.66469C12.5624 8.53989 13 8.20114 13 7.35131V3.04869C13 2.19886 12.5624 1.86011 12.3024 1.73531ZM5.86585 4.83154C5.21268 4.83154 4.67366 4.33234 4.67366 3.71429C4.67366 3.09623 5.21268 2.59703 5.86585 2.59703C6.51902 2.59703 7.05805 3.09623 7.05805 3.71429C7.05805 4.33234 6.51902 4.83154 5.86585 4.83154Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
